import { AtSymbolIcon, PhoneIcon } from '@heroicons/react/24/outline';
import { StyledLink } from '../ui';
import { useTranslation } from 'react-i18next';

export interface IHeaderProps {
  actions?: React.ReactNode;
}

export function Header(props: IHeaderProps) {
  const { t } = useTranslation('offer-package');

  return (
    <div>
      <div className="print:flex items-center justify-center my-6 hidden">
        <img
          src="https://cdn.mandira-ayurveda.at/images/logo/2024/dark_cyan_text_black.png"
          alt="Logo"
          width="130px"
          height="100px"
        ></img>
      </div>

      <header className=" py-4 print:hidden">
        <div className="container grid grid-cols-[1fr_auto_1fr] items-center px-2 sm:hidden">
          <div className="flex items-center justify-start gap-2">
            <StyledLink
              href="tel:+4333332801"
              classNames="flex items-center gap-1"
            >
              <PhoneIcon className="w-4 h-4"></PhoneIcon>
              <span className="sr-only">{t('header.call')}</span>
            </StyledLink>

            <StyledLink
              href="mailto:info@mandira-ayurveda.at"
              classNames="flex items-center gap-1"
            >
              <AtSymbolIcon className="w-4 h-4"></AtSymbolIcon>
              <span className="sr-only">{t('header.mail')}</span>
            </StyledLink>
          </div>

          <div className="flex justify-center">
            <a href="https://www.mandira-ayurveda.at">
              <img
                className="h-8"
                alt="Logo Mandira"
                src="https://cdn.mandira-ayurveda.at/images/icon/2024/dark_cyan.png"
              ></img>
              <span className="sr-only">{t('header.to-homepage')}</span>
            </a>
          </div>

          <div className="flex sm:hidden items-center justify-end">
            {props.actions}
          </div>
        </div>

        <div className="container hidden grid-cols-[1fr_auto_1fr] items-center px-2 sm:grid">
          <div />

          <div className="flex justify-center">
            <a href="https://www.mandira-ayurveda.at">
              <img
                className="h-16"
                alt="Logo Mandira"
                src="https://cdn.mandira-ayurveda.at/images/logo/2024/dark_cyan_text_black.png"
              ></img>
              <span className="sr-only">{t('header.to-homepage')}</span>
            </a>
          </div>

          <div id="header-actions" className="hidden sm:flex gap-2 justify-end">
            <StyledLink
              href="tel:+4333332801"
              classNames="flex items-center gap-1"
            >
              <PhoneIcon className="w-4 h-4"></PhoneIcon> {t('header.call')}
            </StyledLink>

            <StyledLink
              href="mailto:info@mandira-ayurveda.at"
              classNames="hidden md:flex items-center gap-1"
            >
              <AtSymbolIcon className="w-4 h-4"></AtSymbolIcon>{' '}
              {t('header.mail')}
            </StyledLink>

            {props.actions}
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
